import { Toaster } from './components/ui/sonner';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Stages } from './components/Stages';
import { About } from './components/About';
import { Features } from './components/Features';
import { Services } from './components/Services';
import { Location } from './components/Location';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { SkipToContent } from './components/SkipToContent';
import { useAnalytics } from './hooks/useAnalytics';
import { useHashNavigation } from './hooks/useHashNavigation';

export default function App() {
  // Initialize analytics
  useAnalytics();

  // Initialize hash-based navigation
  useHashNavigation(['hero', 'stages', 'about', 'features', 'services', 'location', 'contact']);

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900">
      <SkipToContent />
      <Toaster position="top-right" />
      <Header />
      <main id="main-content">
        <Hero />
        <Stages />
        <About />
        <Features />
        <Services />
        <Location />
        <Contact />
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  );
}
